"use strict";

import * as Request from './Request';
import ApiEndpoints from './ApiEndpoints';

/**
 * Get migration status for the signed-in user.
 *
 * @return {Promise<MigrationStatusDTO>}
 */
export function getMigrationStatus() {
    return Request.getAuthRequestPromise({
        url: ApiEndpoints.GET_MIGRATION_STATUS,
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + ApiEndpoints.VISION360_AUTH_KEY,
        }
    });
}

/**
 * Start account migration (accept terms and enqueue migration).
 *
 * @return {Promise<*>}
 */
export function requestMigration() {
    return Request.getAuthRequestPromise({
        url: ApiEndpoints.REQUEST_MIGRATION,
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + ApiEndpoints.VISION360_AUTH_KEY,
        }        
    });
}
